export default {
    props: {
        toggleContentVisibilityOnMobile: { type: Boolean, default: true },
        initialShowContentOnXs: { type: Boolean, default: undefined },
    },
    data() {
        return {
            showContentOnXs: false,
        }
    },
    mounted(){
        this.showContentOnXs = this.initialShowContentOnXs != undefined ? this.initialShowContentOnXs : this.isFirstUnit;
    },
    computed: {
        isFirstUnit(){
            const firstUnit = document.querySelectorAll('.w-unit, .w-table-unit', '.w-entry-unit')[0];
            return firstUnit != undefined && firstUnit == this.$el;
        },
        showToggleVisibility() {
            return this.toggleContentVisibilityOnMobile && this.$vuetify.breakpoint.xsOnly;
        },
        isUnitContentVisible() {
            if (!this.showToggleVisibility)
                return true;
            
            return this.showContentOnXs;
        },
    },
    methods: {
        getIsArrowClass() {
            return this.showContentOnXs ? 'w-mobile-unit-content-icon__is-active' : '';
        }
    }
}
